import { GET_ALL_ADMISSION_PROGRAMS } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_ADMISSION_PROGRAMS:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getAllAdmissionProgram.js